import storage from 'shared/storage';

// Help settings are remembered per signed-in user on this browser: the Help
// tips switch and whether the product tour has already run. The admin keeps
// the signed-in user under storage 'user' (see apollo.js); with nobody
// signed in every read and write shares one 'anon' slot.
//
// Storage can be missing or throw (private windows, blocked site data), so
// values also live in memory for the rest of the session.

const memory = {};

export const currentUserId = () => {
  try {
    const user = storage.get('user');
    return user && user.id != null ? String(user.id) : 'anon';
  } catch (e) {
    return 'anon';
  }
};

export const userKey = (base, userId = currentUserId()) => `${base}:${userId}`;

export const readFlag = (key) => {
  if (Object.prototype.hasOwnProperty.call(memory, key)) return memory[key];
  try {
    return window.localStorage.getItem(key);
  } catch (e) {
    return null;
  }
};

export const writeFlag = (key, value) => {
  memory[key] = value;
  try {
    window.localStorage.setItem(key, value);
    return true;
  } catch (e) {
    return false;
  }
};

// Tests only: forget the in-memory copies.
export const resetMemory = () => {
  Object.keys(memory).forEach((key) => {
    delete memory[key];
  });
};
